import React, { createContext, useContext, useState, useEffect } from 'react';

const FeatureFlagContext = createContext({ aiEnabled: false, setAiEnabled: () => {} });

const STORAGE_KEY = 'projectly_ai_enabled';

export function FeatureFlagProvider({ children }) {
  const [aiEnabled, setAiEnabled] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, aiEnabled);
  }, [aiEnabled]);

  return (
    <FeatureFlagContext.Provider value={{ aiEnabled, setAiEnabled }}>
      {children}
    </FeatureFlagContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(FeatureFlagContext);
}
